@if (formGroup()) {
  <div class="access">
    <mat-card class="row">
      <mat-card-content>
        <mat-label class="label">Client Admission</mat-label>
        <app-client-picker [formGroup]="formGroup()!" [meta]="metaClients" [model]="admission()" [node]="node()" groupBy="parent.name" [readonly]="readonly()"></app-client-picker>
      </mat-card-content>
    </mat-card>
  </div>
}
